import { render, staticRenderFns } from "./BSShowInvoiceData.vue?vue&type=template&id=2d9ac43f"
import script from "./BSShowInvoiceData.vue?vue&type=script&lang=js"
export * from "./BSShowInvoiceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports